module.exports = __webpack_public_path__ + "static/media/investment-property.ea35f0db.svg";